import React from "react";
import { Container } from "react-bootstrap";
import "../Navbar/Navbar.css"
import "./Footer.css"
function Footer(Prop) {
  return <>
    <div className="aff-footer">
      <div style={{ padding : "10px", paddingTop : "20px", paddingBottom : "20px", boxSizing : "border-box",backgroundColor:"rgb(29, 66, 104)" }}>
        <div className="footer-wrapper">
          <div className="footer-logo">
            <img src="/images/logo.png"></img>
          </div>
          <div className="footer-copyright">
            <p>All rights reserved &copy; Arba777 Affiliates</p>
          </div>
        </div>
      </div>
    </div>
  </>
}

export default Footer
